import { CiscoSetup } from "js/jsx/src/classes/settings/integrations/ciscoSetup.jsx";

export default function ciscoSetup() {

    var ciscoSetup = function () {
        quosal.ui.react.render(<CiscoSetup />, document.getElementById('currentDocument'));
        $('#pageName').val('ciscosetup.quosalweb');
    };
    ciscoSetup();
}